module.exports = __webpack_public_path__ + "assets/img/small-logo.7545d610.png";